import * as dateFnsLocales from 'date-fns/locale';
import { Locale } from 'date-fns';

import i18n from './i18n.ts';

interface Locales {
  [key: string]: Locale;
}

const getDateFnsLocale = (): Locale => {
  const locales: Locales = {
    de: dateFnsLocales.de,
    fr: dateFnsLocales.fr,
    it: dateFnsLocales.it,
    rm: dateFnsLocales.de,
    en: dateFnsLocales.enUS,
  };

  return locales[i18n.language];
};

export default getDateFnsLocale;